module.exports = __webpack_public_path__ + "static/media/application.059116c5.png";